var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.image)?_c('li',{staticClass:"c-screen"},[_c('p',{staticClass:"c-screen__text p-table__left"},[_vm._v(" "+_vm._s(_vm.image.caption)+" ")]),_c('img',{staticClass:"c-screen__image p-table__right",attrs:{"src":_vm.image.url}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }